module.exports = __webpack_public_path__ + "img/11.8df47858.png";